import React, { Suspense, useEffect } from "react";
import { Route, Switch, useLocation } from "react-router";
import { useSelector } from "react-redux";
import { clearCaches } from "./methods";
import { Loading } from "./components";
import Error from "./pages/Error";

const Login = React.lazy(() => import("./pages/Login"));
const MainLayout = React.lazy(() => import("./layouts/MainLayout"));

export default function App() {
  const mainLayoutPaths = [
    "/",
    "/raspberries",
    "/raspberries/:id",
    "/categories",
    "/users",
    "/tickets",
    "/tickets/:id",
  ];
  const location = useLocation();
  const loading = useSelector((state) => state.loading.length !== 0);
  const scrollTop = () => window.scrollTo(0, 0);
  useEffect(scrollTop, [location.pathname]);
  useEffect(clearCaches, []);
  return (
    <React.Fragment>
      {loading && <Loading />}
      <Suspense fallback={<Loading />}>
        <Switch>
          <Route path="/login" component={Login} exact />
          <Route path={mainLayoutPaths} component={MainLayout} exact />
          <Route path="*" component={Error.Error404} />
        </Switch>
      </Suspense>
    </React.Fragment>
  );
}
